module.exports = __webpack_public_path__ + "static/media/HANHUI.7d937a76.png";